import React from 'react';

function Information({header, content}) {

    return (
        <>
            <h1>{header}</h1>
            {content}
        </>
    );
}

export default Information;
